export const dateToLocalDateString = (date, locale) => {
    return new Intl.DateTimeFormat(locale, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    }).format(date);
};
//# sourceMappingURL=date.js.map